import React from "react";
import PropTypes from "prop-types";


// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

import SpindlApi from "modules/spindl-api";

class QuoteService extends React.Component {
    state = {
      value: 0,
      rateCards : []

    };
    async componentDidMount(){

        const rateCards = await SpindlApi.readRateCards()
        console.log("Rate Cards", rateCards)
        this.setState({rateCards:rateCards})
    }
    renderRateCardList(){
        const { classes } = this.props;
        return (this.state.rateCards.map(
            (rateCard)=>{
                return (
                    <GridItem xs={12} sm={12} md={4}>
                    <Card chart>
                    <CardHeader color="warning" >
                        <h3 className={classes.cardTitleWhite}> {rateCard.cardType} </h3>
                    </CardHeader>
                    <CardBody>
                        
                        <p className={classes.cardCategory}>
                        {/*rateCard.desc*/}No description
                        </p>
                    </CardBody>
                    <CardFooter chart>
                        <div className={classes.stats}>
                        <a href={"rate_card/"+rateCard.id}><Icon>create</Icon>manage rate card</a>
                        </div>
                    </CardFooter>
                    </Card>
                </GridItem>
                )
            })
        )
    }
    render() {
      
      const rateCardList = this.renderRateCardList();
      return (
        <div>
          <GridContainer>
              {rateCardList}
          </GridContainer>
        </div>
      );
    }
  }
  
  QuoteService.propTypes = {
    classes: PropTypes.object.isRequired
  };
  
  export default withStyles(dashboardStyle)(QuoteService);
  


// WEBPACK FOOTER //
// ./src/views/QuoteService/QuoteService.jsx